import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { updatePreferences } from "app/services/accountPreference/accountPreference";
import { BASE_URL } from "static/constants";

export const accountPreferenceApi = createApi({
  reducerPath: "accountPreferenceApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    updateAccountPreferences: builder.mutation({
      queryFn: (payload) => {
        return { data: updatePreferences(payload) };
      },
    }),
  }),
});

export const { useUpdateAccountPreferencesMutation } = accountPreferenceApi;
